/* eslint-disable react/no-did-mount-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import classNames from 'classnames';

import SVG from 'components/widgets/icons/svg';


export default class ActionCompleteIndicator extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };

  constructor() {
    super();
    this.state = {
      fadeOut: false,
      hidden: false,
      // Show the indicator briefly, then fade it out
      // // Save the timeout in the state so we can cancel it if the component unmounts
      timeout: window.setTimeout(() => this.setState({ fadeOut: true }), 5000)
    };
  }

  componentDidMount() {
    // Once the indicator has finished fading out, hide it so it doesn't take up space
    const el = $(ReactDOM.findDOMNode(this));
    el.on('transitionend', () => this.setState({ hidden: true }));
  }

  componentWillUnmount() {
    window.clearTimeout(this.state.timeout);
    const el = $(ReactDOM.findDOMNode(this));
    el.off('transitionend');
  }

  render() {
    return (
      <SVG
        src="svg/check.svg"
        className={classNames('action-complete', this.props.className, {
          'fade-out': this.state.fadeOut,
          'slide-left': this.state.hidden
        })}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widgets/state-indicators/complete-indicator.js